const DATA_TEST_IDS = {
  modulePageModulePage: 'module__module-page_module-page',
  customRoleList: 'module__module-page_custom-role-list',
  modulePageRoleLists: 'module__module-page_role-lists',
} as const;

export default DATA_TEST_IDS;
